import BaseSelectBox from 'components/atoms/base-select-box';
import { AutoComplete, Input } from 'antd';
import BaseLoader from 'components/atoms/base-loader';
import InputSearchIcon from 'components/atoms/icons/inputSearchIcon';
import useUser from 'utils/useUser';

import s from './styles.module.scss';

import type { ChangeEvent } from 'react';

interface SearchPatientsByTypeProps<T> {
  typeOptions: { value: string; label: string; placeholder: string }[];
  defaultTypeValue: string;
  onTypeChange: (value: T) => void;
  typeValue: T;
  onSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  searchValue: string;
  isLoading: boolean;
  placeholder?: string;
  dataOptions: {
    value: string;
    label: string;
  }[];
  onSelect: (
    name: string,
    option: {
      value: string;
      label: string;
    },
  ) => void;
  searchWith?: number;
  onClear: () => void;
}

const SearchPatientsByType = <T,>({
  typeOptions,
  defaultTypeValue,
  dataOptions,
  typeValue,
  searchValue,
  isLoading,
  placeholder,
  searchWith = 250,
  onTypeChange,
  onSelect,
  onSearch,
  onClear,
}: SearchPatientsByTypeProps<T>) => {
  const { isMobileDevice } = useUser();

  return (
    <div className={s['inputs-wrapper']}>
      <div data-cy="patient-filter-list-dropdown">
        <BaseSelectBox
          options={typeOptions}
          defaultValue={defaultTypeValue}
          className={s.dropdown}
          onChange={onTypeChange}
          value={typeValue}
        />
      </div>
      <div data-cy="patient-filter-input">
        <AutoComplete
          popupClassName="certain-category-search-dropdown"
          popupMatchSelectWidth
          style={{ width: isMobileDevice ? '100%' : searchWith }}
          options={dataOptions ?? []}
          notFoundContent={
            isLoading ? (
              <BaseLoader loading={isLoading} height={20} width={20} />
            ) : (
              'No Data'
            )
          }
          onSelect={onSelect}
          value={searchValue}
          optionRender={(option) => (
            <div data-cy="search-input-option">{option.label}</div>
          )}
        >
          <Input
            placeholder={placeholder}
            className={s.search}
            onChange={onSearch}
            allowClear={onClear !== undefined}
            onClear={onClear}
            suffix={searchValue ? null : <InputSearchIcon />}
          />
        </AutoComplete>
      </div>
    </div>
  );
};
export default SearchPatientsByType;
